// extracted by mini-css-extract-plugin
export default {"softwaresCont":"Softwares_softwaresCont__q7zzJ","softwares":"Softwares_softwares__R2xSl"};